export class HhgRatesCsvDownload {
    controlId : any;
    ratesBidcyclesId:any;
    rateTypes: any[];
    carrierId : any[];
    sroMasterIdList : any[];
    originId : any;
    destinationId : any;  
    transportationType: any[]; 
    allCarriersSelected: any;
}